import { render, staticRenderFns } from "./PrivilegeProgram.vue?vue&type=template&id=4d4bf53b&scoped=true&"
import script from "./PrivilegeProgram.vue?vue&type=script&lang=js&"
export * from "./PrivilegeProgram.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeProgram.vue?vue&type=style&index=0&id=4d4bf53b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bf53b",
  null
  
)

export default component.exports